import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-stables-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold text-stables-400 mb-4">The Stables</h3>
            <p className="text-stables-300 mb-6 leading-relaxed">
              Your gateway to a magical horse riding experience. We offer unique and memorable 
              horse riding experiences for the whole family in the beautiful countryside of Pretoria East.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/thestableshorserides"
                aria-label="Facebook"
                className="hover:opacity-75 transition-opacity duration-200"
              >
                <img src="/facebook.png" alt="Facebook" className="w-8 h-8 object-contain" />
              </a>
              <a
                href="https://www.instagram.com/thestables.horserides/"
                aria-label="Instagram"
                className="hover:opacity-75 transition-opacity duration-200"
              >
                <img src="/instagram.png" alt="Instagram" className="w-8 h-8 object-contain" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/horse-rides" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  Horse Rides
                </Link>
              </li>
              <li>
                <Link to="/horse-ride-picnic" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  Horse Ride & Picnic
                </Link>
              </li>
              <li>
                <Link to="/parties" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  Parties
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-stables-400 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-stables-300">
                  The Stables, R964,<br />
                  Pretoria East, Boschkop
                </span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-stables-400 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+27699464074" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  +27 69 946 4074
                </a>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-stables-400 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:info@thestableshorserides.co.za" className="text-stables-300 hover:text-stables-400 transition-colors duration-200">
                  info@thestableshorserides.co.za
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-stables-800">
        <div className="max-w-6xl mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-stables-400 text-sm mb-4 md:mb-0">
              ©2023 by The Stables. All rights reserved.
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-stables-400 text-sm">Follow us on</span>
              <a
                href="https://www.facebook.com/thestableshorserides"
                aria-label="Facebook"
                className="hover:opacity-75 transition-opacity duration-200"
              >
                <img src="/facebook.png" alt="Facebook" className="w-6 h-6 object-contain" />
              </a>
              <a
                href="https://www.instagram.com/thestables.horserides/"
                aria-label="Instagram"
                className="hover:opacity-75 transition-opacity duration-200"
              >
                <img src="/instagram.png" alt="Instagram" className="w-6 h-6 object-contain" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 